



































// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';

// Components
import Btn, { BtnColor, BtnWidth, BtnHeight, BtnFontSize, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import SignaturePad from '@/shared/components/signature-pad.component.vue';

@Component({
    components: {
        Btn,
        SignaturePad,
    },
})
export default class SignaturePartial extends Vue {
    private btnColor = BtnColor;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private btnFontSize = BtnFontSize;
    private btnWidth = BtnWidth;
    private btnHeight = BtnHeight;
    private signaturePadReference !: SignaturePad;
    private hasSignature = false;
    private literals = {
        btnRemake: 'Rehacer',
        btnSign: 'Firmar',
    };


    private mounted() {
        this.signaturePadReference = ( this.$refs.signaturePad as SignaturePad);
    }


    private closeModal() {
        this.$emit('close-modal');
    }

    private clearPad() {
        this.signaturePadReference.clearPad();
    }

    private setHasSignature(value: boolean) {
        this.hasSignature = value;
        this.hasSignature = value;
    }

    private sign() {
        this.$emit('signature', this.signaturePadReference.getSignature());
    }
}
